<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loader"
      :pagination.sync="paginationLocal"
      :rows-per-page-items="headerPageItems"
      :total-items="paginationLocal.totalItems"
      item-key="id"
    >
      <v-progress-linear slot="progress" color="accent" indeterminate />
      <template slot="items" slot-scope="props">
        <tr
          v-if="
            !filterObj ||
              !filterObj.hideInProgressTask ||
              !props.item.inProgress
          "
        >
          <td
            v-if="checkIfShown('name')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="body-1 font-weight-bold">
              {{ props.item.name || props.item.formKey }}
            </div>
          </td>
          <td
            v-if="checkIfShown('description')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="caption">
              {{ props.item.description }}
            </div>
          </td>
          <td
            v-if="taskType !== 'claimed' && checkIfShown('assignee')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div v-if="props.item.assignee" class="body-1 font-weight-bold">
              {{ props.item.assignee }}
            </div>
          </td>
          <td
            v-if="checkIfShown('externalRequestedBy')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div v-if="props.item.assignee" class="body-1 font-weight-bold">
              {{ props.item.externalRequestedBy }}
            </div>
          </td>
          <td
            v-if="checkIfShown('taskType')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div v-if="!groupItem" class="body-2">
              {{
                props.item.taskType === 'APPROVAL_TASK'
                  ? 'Approval Task'
                  : 'User Input task'
              }}
            </div>
          </td>
          <td
            v-if="checkIfShown('createdAt')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="body-1 font-weight-bold">
              {{ convertDate(props.item.createdAt) }}
            </div>
          </td>
          <td
            v-if="checkIfShown('due')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="body-1 font-weight-bold">
              {{ convertDate(props.item.due) }}
            </div>
          </td>
          <td
            v-if="checkIfShown('followUp')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="body-1 font-weight-bold">
              {{ convertDate(props.item.followUp) }}
            </div>
          </td>
          <td
            v-if="checkIfShown('dimension1')"
            class="text-xs-left"
            @click="props.expanded = !props.expanded"
          >
            <div class="py-1">
              <task-dimensions-and-metrics :task="props.item" />
            </div>
          </td>
          <td
            class="align-center justify-center fill-height"
            v-if="checkIfShown('action')"
          >
            <v-flex
              v-if="
                taskType === 'unclaimed' ||
                  props.item.inProgress ||
                  (taskType === 'claimed' &&
                    props.item.taskType === 'APPROVAL_TASK')
              "
            >
              <v-layout align-center justify-end fill-height row wrap>
                <v-flex xs6>
                  <v-tooltip bottom>
                    <v-btn
                      v-if="
                        taskType === 'claimed' &&
                          props.item.taskType === 'APPROVAL_TASK'
                      "
                      slot="activator"
                      :class="props.item.inProgress ? 'grey' : 'red'"
                      :loading="approveRejectLoader || props.item.inProgress"
                      flat
                      icon
                      @click.stop="
                        confirmApproveRejectAction(props.item, false)
                      "
                    >
                      <v-icon>thumb_down_off_alt</v-icon>
                    </v-btn>
                    <span>Reject Task</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6>
                  <v-tooltip bottom>
                    <v-btn
                      v-if="
                        taskType === 'claimed' &&
                          props.item.taskType === 'APPROVAL_TASK'
                      "
                      slot="activator"
                      :class="props.item.inProgress ? 'grey' : 'green'"
                      :loading="approveRejectLoader || props.item.inProgress"
                      flat
                      icon
                      @click.stop="confirmApproveRejectAction(props.item, true)"
                    >
                      <v-icon>thumb_up_off_alt</v-icon>
                    </v-btn>
                    <span>Approve Task</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    v-if="taskType === 'unclaimed'"
                    :loading="approveRejectLoader || props.item.inProgress"
                    class="text-capitalize green"
                    flat
                    outline
                    @click.stop="claimAction(props.item)"
                  >
                    Claim
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <div v-if="props.item.inProgress">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-chip small class="caption">
                          In-Progress
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card>
          <v-toolbar flat dense>
            Task Details
            <v-spacer></v-spacer>
            <task-comments :task-hex-id="props.item.hexId" />
            <related-task-timeline
              :task-id="props.item.hexId"
              :show-time="showTime"
            ></related-task-timeline>
            <v-menu
              v-model="taskMenu"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  :loading="approveRejectLoader || props.item.inProgress"
                >
                  <v-icon>
                    more_vert
                  </v-icon>
                </v-btn>
              </template>
              <v-list two-line>
                <v-menu
                  v-model="delegateMenu"
                  offset-y
                  bottom
                  scrollable
                  max-height="200"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-tile
                      v-if="taskType === 'claimed' && can('TASK_DELEGATE')"
                      v-on="on"
                      :disabled="
                        props.item.inProgress || taskCandidateUsersLoader
                      "
                      @click.stop="delegateStart(props.item)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <v-progress-circular
                            size="20"
                            indeterminate
                            v-if="taskCandidateUsersLoader"
                          ></v-progress-circular>
                          Delegate
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          >Delegate the task to Colleague
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <v-list
                    two-line
                    v-if="delegateUsers.length > 0"
                    style="border-radius: 5px"
                  >
                    <v-list-tile
                      v-for="(item, index) in delegateUsers"
                      :key="index"
                      @click="delegateAction(props.item, item)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.userId }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.type }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-list v-else style="border-radius: 5px">
                    <v-list-tile class="warning">
                      <v-list-tile-title>
                        <v-progress-circular
                          size="20"
                          indeterminate
                          v-if="taskCandidateUsersLoader"
                        ></v-progress-circular>
                        No users found for the task delegation
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-list-tile
                  @click.stop="claimAction(props.item)"
                  :disabled="approveRejectLoader || props.item.inProgress"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ getCaption }}</v-list-tile-title>
                    <v-list-tile-sub-title
                      >{{ getSubtitle }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click.stop="triggerReplicateTask(props.item)">
                  <v-list-tile-content>
                    <v-list-tile-title>Replicate Task</v-list-tile-title>
                    <v-list-tile-sub-title
                      >Replicate task to fix inconsistency
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
          <task-details
            :task="props.item"
            :task-type="taskType"
            :task-id="props.item.id"
            @task-refresh="notifyTaskListRefresh"
          >
          </task-details>
        </v-card>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="success" icon="info">
          No Tasks found!
        </v-alert>
      </template>
      <template slot="no-results">
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" not found.
        </v-alert>
      </template>
    </v-data-table>
    <v-dialog v-if="confirmDialog" v-model="confirmDialog" max-width="500px">
      <v-card style="border-radius:10px">
        <v-card-title>
          Confirm {{ confirmAction ? 'Approve' : 'Reject' }}
        </v-card-title>
        <v-card-text>
          Task Selected: <b>{{ selectedItem.name }}</b> created on
          {{ selectedItem.createdAtLocal }} <br />
          Confirm to <b>{{ confirmAction ? 'Approve' : 'Reject' }}</b> the task
          ?
          <b
            >(All Task Items will be
            {{ confirmAction ? 'Approved' : 'Rejected' }})</b
          >&nbsp;
        </v-card-text>
        <v-textarea
          v-model="remarks"
          hint="Please enter the approver remarks (minimum of 2 characters)"
          label="Remarks"
          class="px-3"
          outline
        >
        </v-textarea>
        <file-input
          :options="attachmentOptions"
          @filepick="updateFileLink"
        ></file-input>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="mt-2 text-capitalize"
            outline
            v-if="taskType === 'claimed'"
            :loading="approveRejectLoader || taskCompleteLoader"
            @click.stop="confirmDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            class="mt-2 text-capitalize primary"
            outline
            v-if="taskType === 'claimed'"
            :loading="approveRejectLoader || taskCompleteLoader"
            :disabled="checkRemarks"
            @click.stop="handleApproveRejectAction()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TaskDetails from '@/components/task-lists/TaskDetails'
import TaskComments from '@/components/task-lists/TaskComments'
import RelatedTaskTimeline from '@/components/task-lists/RelatedTaskTimeline'
import TaskDimensionsAndMetrics from '@/components/task-lists/TaskDimensionsAndMetrics'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import FileInput from '@/components/common/form-generator/FileInput'

export default {
  name: 'TaskTable',
  components: {
    TaskDetails,
    FileInput,
    TaskDimensionsAndMetrics,
    TaskComments,
    RelatedTaskTimeline
  },
  props: {
    headers: Array,
    items: Array,
    showTime: Boolean,
    headerPageItems: Array,
    loader: {
      type: Boolean,
      default: false
    },
    groupItem: {
      type: Boolean,
      default: false
    },
    filterObj: {
      type: Object,
      default: null
    },
    pagination: Object,
    taskType: {
      type: String,
      default: 'claimed'
    },

    search: String
  },
  data() {
    return {
      paginationLocal: {
        sortBy: 'createdAt',
        descending: true,
        rowsPerPage: 10,
        totalItems: 0,
        page: 1
      },
      approveRejectLoader: false,
      taskCompleteLoader: false,
      confirmAction: false,
      confirmDialog: false,
      expanded: false,
      selectedItem: null,

      remarks: '',
      attachmentOptions: {
        name: 'fileinput',
        acceptFormats: '',
        multiple: 'true'
      },
      fileAttachments: [],

      taskMenu: false,
      delegateMenu: false,
      taskCandidateUsersLoader: false
    }
  },
  computed: {
    ...mapState({
      comments: state => state.tasks.comments,
      taskExecution: state => state.tasks.execution,
      user: state => state.session.user,
      taskCandidateUsers: state => state.tasks.taskCandidateUsers
    }),
    ...mapGetters({
      can: 'can'
    }),
    delegateUsers() {
      return this.taskCandidateUsers
        .filter(p => p.userId !== null && p.userId !== this.user.name)
        .filter((v, i, a) => a.findIndex(t => t.userId === v.userId) === i)
    },
    checkRemarks() {
      return this.remarks.length < 2
    },
    getCaption() {
      if (this.taskType === 'claimed') {
        return 'Un-Claim'
      } else if (this.taskType === 'unclaimed') {
        return 'Claim'
      } else if (this.taskType === 'support') {
        return 'Close'
      }
      return {}
    },
    getSubtitle() {
      if (this.taskType === 'claimed') {
        return 'The task will get posted back to the Group'
      } else if (this.taskType === 'unclaimed') {
        return 'Take ownership over the Task'
      } else if (this.taskType === 'support') {
        return 'Close the support ticket'
      }
      return {}
    }
  },
  watch: {
    pagination() {
      this.paginationLocal = this.pagination
    },
    paginationLocal() {
      this.$emit('pagination-update', this.paginationLocal)
    }
  },
  mounted() {
    this.paginationLocal = this.pagination
  },
  methods: {
    async delegateAction(task, user) {
      try {
        let body = {}
        body.userId = user.userId

        await this.$store.dispatch('delegateTask', {
          id: this.task.id,
          body: body
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Task delegated Successfully',
          description: `The task  ${this.task.id} has been assigned to ${user.userId}.`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.notifyTaskListRefresh()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to perform the action',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },
    async delegateStart(task) {
      this.taskCandidateUsersLoader = true
      await this.$store.dispatch('fetchTaskCandidateUsers', task)
      this.taskCandidateUsersLoader = false
    },
    updateFileLink: function(link) {
      this.fileAttachments = link
    },
    checkIfShown(fieldName) {
      return !!this.headers.filter(
        item => item.value === fieldName && item.isSelected === true
      ).length
    },
    convertDate(date) {
      if (!date) return 'Not Set'
      return this.showTime
        ? moment(date).format('MMM Do YYYY, h:mm:ss a')
        : moment(date).format('MMM Do YYYY')
    },

    async confirmApproveRejectAction(item, approved) {
      this.confirmAction = approved
      this.selectedItem = item
      this.confirmDialog = true
    },
    notifyTaskListRefresh() {
      this.$emit('task-refresh')
    },
    async handleRejectTask() {
      this.approveRejectLoader = true
      await this.completeTaskActionDirect(this.task, false)
      this.approveRejectLoader = false
      this.notifyTaskListRefresh()
    },
    async handleApproveTask() {
      this.approveRejectLoader = true
      await this.completeTaskActionDirect(this.task, true)
      this.approveRejectLoader = false
      this.notifyTaskListRefresh()
    },
    async handleApproveRejectAction() {
      if (this.confirmAction) {
        await this.handleApproveTask()
      } else {
        await this.handleRejectTask()
      }
      this.confirmDialog = false
    },
    async triggerReplicateTask(task) {
      this.taskMenu = false
      try {
        await this.$store.dispatch('replicateEngineTask', task.id)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Task replicate request raised Successfully',
          description: `Task replicate request raised Successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to raise replicate request for the Task',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },
    async completeTaskActionDirect(task, approved) {
      this.taskCompleteLoader = true
      try {
        let body = {}
        body.taskId = this.selectedItem.id
        body.remarks = this.remarks
        body.fileAttachment = this.fileAttachments
        await this.$store.dispatch('completeTaskDirect', {
          id: this.selectedItem.id,
          approved: approved,
          body: body
        })
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Task has been Completed',
          description: 'User Task Completed Successfully',
          type: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to complete the Task',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskCompleteLoader = false
    },

    numberFormat(param) {
      return parseFloat(param).toLocaleString()
    },
    async claimAction(task) {
      try {
        this.taskMenu = false
        if (this.taskType === 'unclaimed') {
          let res = true
          if (task.assignee && task.assignee.length > 0) {
            res = await this.$confirm(
              `The selected task is assigned to '${task.assignee}'! Do you really want to claim it?`,
              {
                title: 'Warning'
              }
            )
          }
          if (res) {
            let body = {}
            body.userId = this.user.name

            await this.$store.dispatch('claimTask', {
              id: task.id,
              body: body
            })
            await this.$store.dispatch('directNotification', {
              type: 'success',
              message: 'Task claimed Successfully',
              description: `The task  ${task.id} has been assigned to ${this.user.name}.`,
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          }
        } else if (this.taskType === 'claimed') {
          await this.$store.dispatch('unclaimTask', task.id)
          await this.$store.dispatch('directNotification', {
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            message: 'Task has been Unclaimed',
            description: `The task ${task.id} unclaimed Successfully`,
            type: 'success'
          })
        } else if (this.taskType === 'support') {
          try {
            let body = {}
            body.taskId = this.task.id
            body.remarks = this.remarks
            body.fileAttachment = this.fileAttachments
            await this.$store.dispatch('completeTask', {
              id: task.id,
              body: body
            })
            await this.$store.dispatch('directNotification', {
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
              message: 'Task has been Completed',
              description: 'User Task Completed Successfully',
              type: 'success'
            })
          } catch (e) {
            await this.$store.dispatch('directNotification', {
              message: 'Unable to complete the Task',
              description: e.response
                ? e.response.data.message
                : 'Error unknown! Kindly retry',
              type: 'error',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          }
        }
        this.notifyTaskListRefresh()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to perform the action',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    }
  }
}
</script>

<style scoped></style>
